function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "a");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Design",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Evaluation",
  transform: "translate(-497.000000, -314.000000)",
  fill: "#003749",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(256.000000, 290.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M249.669497,39.6785071 L256.503869,32.844169 C256.834351,32.5171892 256.834351,31.982843 256.503869,31.6523613 L249.669497,24.821525 C249.342551,24.4910434 248.808171,24.4910434 248.477723,24.821525 L247.69725,25.6019988 C247.359764,25.9359824 247.366768,26.480903 247.711326,26.8078484 L251.947644,30.8437694 L241.843748,30.8437694 C241.376178,30.8437694 241,31.2199473 241,31.6875174 L241,32.8125148 C241,33.2800849 241.376178,33.6562627 241.843748,33.6562627 L251.947644,33.6562627 L247.711326,37.6921838 C247.370304,38.0191292 247.363266,38.5640498 247.69725,38.8980334 L248.477723,39.6785071 C248.804669,40.0089888 249.339049,40.0089888 249.669497,39.6785071 Z",
  id: "a"
}))));

var SvgArrowRight = function SvgArrowRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-right.1e46b2ff.svg";
export { ForwardRef as ReactComponent };